import './parent';
import color_palette_list from '../gb-helper/color_palette';
import block_icons from '../icons/icon_in_list';
import { font_family_detailed, all_font_families } from '../gb-helper/font_family_detailed';
import IconPicker  from './icon-picker/index'

const { registerBlockType } = wp.blocks;
const { __ } = wp.i18n;
const { InnerBlocks, RichText, InspectorControls, MediaUpload, MediaUploadCheck } = wp.editor;
const { PanelBody, PanelRow, SelectControl, TextControl, Card, CardBody, Dashicon,
    ToggleControl, Button, RangeControl, TabPanel, ColorPalette, ColorIndicator } = wp.components;

registerBlockType('blocksbakery/icon-list', {
    title: __("Icon", "blocks-bakery"),
    description: __(" This block is used to create a list with image or icons shown as bullets for each list item.", "blocks-bakery"),
    icon: block_icons.flat_icon,
    category: 'blocks-bakery',
    parent: ['blocksbakery/icon-list-child'],
    keywords: [
        __('icon', 'blocks-bakery'),
        __('list', 'blocks-bakery'),
        __('label', 'blocks-bakery')
    ],
    attributes: {
        display_style: {
            type: 'string',
            default: 'Vertical'
        },
        hide_labels: {
            type: 'boolean',
            default: false
        },
        label_value: {
            type: 'string',
            default: '#Label'
        },
        items_gap: {
            type: 'number'
        },
        icon_labels_gap: {
            type: 'number',
            default: 10
        },
        labelMargin: {
            type: 'string'
        },
        icon_alignment: {
            type: 'string',
            default: 'middle'
        },
        displayLabel: {
            type: 'string',
            default: 'inline-block'
        },
        icon_size: {
            type: 'number',
            default:'23',
        },
        bg_size: {
            type: 'number',
            default:'0',
        },
        border: {
            type: 'number',
            default: 0
        },
        radius: {
            type: 'number'
        },
        select_icon: {
            type: 'string',
            default: 'twitter'
        },
        icon_img: {
            type: 'string',
            default: 'icon'
        },
        hide_icon_labels: {
            type: 'boolean',
            default: false
        },
        hide_img_label: {
            type: 'boolean',
            default: false
        },
        text_color_palette: {
            type: 'string',
            default: '#000000',
        },
        icon_color_palette: {
            type: 'string',
            default: '#000000',
        },
        icon_background_color_palette: {
            type: 'string',
        },
        icon_border_color_palette: {
            type: 'string',
            default: 'black'
        },
        hover_text_color_palette: {
            type: 'string',
        },
        hover_icon_color_palette: {
            type: 'string',
        },
        hover_icon_background_color_palette: {
            type: 'string',
        },
        hover_icon_border_color_palette: {
            type: 'string',
        },
        img_background_color_palette: {
            type: 'string',
            default: 'white'
        },
        img_border_color_palette: {
            type: 'string',
            default: '#000000'
        },
        hover_img_background_color_palette: {
            type: 'string',
            default: '#ffffff'
        },
        imgDisplay: {
            type: 'string',
            default: 'none'
        },

        iconDisplay: {
            type: 'string'
        },
        hover_img_border_color_palette: {
            type: 'string',
            default: '#000000'
        },
        img_ID: {
            type: 'number'
        },
        img_URL: {
            type: 'string',
            source: 'attribute',
            attribute: 'src',
            selector: 'img'
        },
        img_alt: {
            type: 'string',
            source: 'attribute',
            attribute: 'alt',
            selector: 'img'
        },
        link_field: {
            type: 'string',
            default: '#'
        },
        text_field: {
            type: 'string',
            default: '#'
        },
        label_size: {
            type: 'number',
        },
        label_fontweight: {
            type: 'number'
        },
        label_fontfamily: {
            type: 'string',
            default:'ABeeZee',
        },
        label_lineheight: {
            type: 'number'
        },
        chngfontem:{
            type:'string',
            default:'px',
        },
        chnglineght:{
            type:'string',
            default:'px',
        },
        icon_selector:
        {
            type:'string',
            default:'fas fa-window-close',
        },


    },
    edit: (props) => {
        var index = font_family_detailed.findIndex(x => x.family === props.attributes.label_fontfamily);
        var font_weight = font_family_detailed[index].variants
        var font_weight_list = []
        for (var i = 0; i < font_weight.length; i++) {
            font_weight_list.push({ label: font_weight[i], value: font_weight[i] })
        }
        const hideLabel = (bool) => {
            if (bool === true) {
                console.log('true')
                props.setAttributes({ displayLabel: 'none' })
            } else if (bool === false) {
                console.log('flase')
                props.setAttributes({ displayLabel: 'inline-block' })
            }
        }
        const iconAlignment = (val) => {
            if (val === 'top') {
                props.setAttributes({ labelMargin: '15px' })
            } else if (val === 'middle') {
                props.setAttributes({ labelMargin: '0px' })
            }
        }
        const hide_icon_control = (val) => {
            console.log(val)
            var hide_icon = document.getElementById('hide-icon')
            if (val === true) {
                hide_icon.style.display = 'none'
            } else if (val === false) {
                hide_icon.style.display = 'block'
            }
        }
        const hide_img_control = (val) => {
            var hide_img = document.getElementById('hide-img')
            if (val === true) {
                hide_img.style.display = 'none'
            } else if (val === false) {
                hide_img.style.display = 'block'
            }
        }
        const select_img = (img) => {
            props.setAttributes({
                img_ID: img.id,
                img_URL: img.url,
                img_alt: img.alt
            })
        }
        const remove_img = (img) => {
            props.setAttributes({
                img_ID: null,
                img_URL: null,
                img_alt: null
            })
        }
        const toggle_tp = () => {
            var x = document.getElementById('toggle_tp');
            if (x.style.display === "none") {
                x.style.display = "block";
            }
            else {
                x.style.display = "none";
            }
        }
        const imgIcon = (new_val) => {
            console.log(new_val)
            var icon_container = document.getElementById('icon-container')
            var img_container = document.getElementById('img-container')
            if (new_val === 'icon') {
                icon_container.style.display = 'block'
                img_container.style.display = 'none'
                props.setAttributes({ iconDisplay: 'inline-block' })
                props.setAttributes({ imgDisplay: 'none' })
            } else if (new_val === 'img') {
                props.setAttributes({ imgDisplay: 'inline-block' })
                props.setAttributes({ iconDisplay: 'none' })
                icon_container.style.display = 'none'
                img_container.style.display = 'block'
            }
        }
        const onChangeIcon = (e) => {
            e.target.style.color = props.attributes.hover_icon_color_palette
            e.target.style.backgroundColor = props.attributes.hover_icon_background_color_palette
            e.target.style.borderColor = props.attributes.hover_icon_border_color_palette
        }
        const sameIcon = (e) => {
            e.target.style.color = props.attributes.icon_color_palette
            e.target.style.backgroundColor = props.attributes.icon_background_color_palette
            e.target.style.borderColor = props.attributes.icon_border_color_palette
        }
        const onChangeLabel = (e) => {
            e.target.style.color = props.attributes.hover_text_color_palette
        }
        const sameLabel = (e) => {
            e.target.style.color = props.attributes.text_color_palette
        }
        const onChangeImg = (e) => {
            e.target.style.backgroundColor = props.attributes.hover_img_background_color_palette
            e.target.style.borderColor = props.attributes.hover_img_border_color_palette
        }
        const sameImg = (e) => {
            e.target.style.backgroundColor = props.attributes.img_background_color_palette
            e.target.style.borderColor = props.attributes.img_border_color_palette
        }
        const changeFontPx = () => {

            var x = document.getElementById("changefontpx")
            var y = document.getElementById("changefontem")
            x.style.textDecoration = "underline"
            y.style.textDecoration = "none"
           props.setAttributes({chngfontem: 'px'})
        }
        const changeFontEm = () => {
            var x = document.getElementById("changefontpx")

            var y = document.getElementById("changefontem")
            x.style.textDecoration = "none"
            y.style.textDecoration = "underline"
            props.setAttributes({chngfontem: 'em'})
        }
        const changeLineheightPx = () => {
            var x = document.getElementById("changelinpx");
            var y = document.getElementById("changelinem");
            x.style.textDecoration = "underline"
            y.style.textDecoration = "none"
            props.setAttributes({chnglineght:'px'})
        }
        const changeLineheightEm = () => {
            var x = document.getElementById("changelinpx");
            var y = document.getElementById("changelinem");
            x.style.textDecoration = "none"
            y.style.textDecoration = "underline"
            props.setAttributes({chnglineght:'em'})
        }
        const reset = () => {
           console.log("helo")
            props.setAttributes({ label_size: '16' })
            props.setAttributes({ label_fontfamily: 'ABeeZee' })
            props.setAttributes({ label_fontweight: '' })
            props.setAttributes({ label_fontweight: '16' })
            props.setAttributes({text_color_palette:'black'})
        }
        return [
            <InspectorControls>
                <PanelBody title={__('General', 'icon-list')}>
                    <ToggleControl
                        label="Hide Labels "
                        checked={props.attributes.hide_labels}
                        onChange={(new_val) => {
                            props.setAttributes({ hide_labels: new_val })
                            hideLabel(new_val)
                        }}
                    />
                    <hr />
                    <RangeControl
                        label='Gap Between Items'
                        help='Note: For better editing experience, the gap between items might look larger than applied. Viewing in frontend will show the actual results.'
                        value={props.attributes.items_gap}
                        step={0.5}
                        min={0}
                        max={100}
                        initialPosition={10}
                        onChange={(new_value) => {
                            props.setAttributes({ items_gap: new_value })
                        }}
                    />
                    <RangeControl
                        label='Gap Between Icon and Labels'
                        value={props.attributes.icon_labels_gap}
                        step={0.5}
                        min={0}
                        max={100}
                        onChange={(new_value) => {
                            props.setAttributes({ icon_labels_gap: new_value })
                        }}
                    />
                    <hr />
                    <SelectControl
                        label={__("Icon Alignment", 'icon-list')}
                        value={props.attributes.icon_alignment}
                        help='Note: This manages the Icon Position with respect to the Label.'
                        options={[
                            { label: 'Top', label: 'top' },
                            { label: 'Middle', label: 'middle' },
                        ]}
                        onChange={(new_val) => {
                            props.setAttributes({ icon_alignment: new_val })
                            iconAlignment(new_val)
                        }}
                    />
                    <RangeControl
                        label='Icon Size'
                        value={props.attributes.icon_size}
                        min={0}
                        max={500}
                        allowReset={true}
                        initialPosition={23}
                        onChange={(new_value) => {
                            props.setAttributes({ icon_size: new_value })
                        }}
                    />
                    <hr />
                    <PanelRow>
                        <p>Typography</p>
                        <div>
                            <Button onClick={reset} style={{ paddingLeft: 7, paddingRight: 7 }}><span><Dashicon icon="image-rotate" style={{ fontSize: 15 }} /></span></Button>
                            <Button style={{ paddingLeft: 7, paddingRight: 7 }}><span><Dashicon icon="admin-tools" style={{ fontSize: 15 }} onClick={toggle_tp} /></span></Button>
                        </div>
                    </PanelRow>
                    <Card id="toggle_tp" style={{ display: "none" }}>
                        <CardBody style={{ paddingTop: 16, paddingBottom: 16, paddingLeft: 10, paddingRight: 10 }}>
                            <div style={{ display: "flex", alignItems: "center" }}>
                                <p style={{ marginRight: 46 }}>Font Size</p>
                                <Button style={{ padding: 1, marginRight: 4, boxShadow: 0, height: 20, backgroundColor: "#e4e5e5", color: "#23282d", borderRadius: "50%" }}>
                                    <span> <Dashicon icon="desktop" style={{ fontSize: 15 }} /></span></Button>
                                <Button style={{ padding: 1, marginRight: 4, boxShadow: 0, height: 20, backgroundColor: "#e4e5e5", color: "#23282d", borderRadius: "50%" }}>
                                    <span><Dashicon icon="tablet" style={{ fontSize: 15 }} /></span></Button>
                                <Button style={{ padding: 1, marginRight: 4, boxShadow: 0, height: 20, backgroundColor: "#e4e5e5", color: "#23282d", borderRadius: "50%" }}>
                                    <span><Dashicon icon="phone" style={{ fontSize: 15 }} /></span></Button>
                                <Button onClick={changeFontPx} id="changefontpx"  style={{  fontSize: 15, paddingLeft: 5, paddingRight: 5 }}><span style={{ height: 30 }}>px</span></Button>
                                <Button onClick={changeFontEm}  id="changefontem" style={{  fontSize: 15, padding: 0 }} ><span style={{ height: 30 }}>em</span></Button>
                            </div>
                            <div className="range-controller-main">
                                <div className="textcoloring">
                                </div>
                                
                                <div className="range-controler" style={{display:"flex"}}>
                                
                                        
                                <div style={{marginRight:"10px",width:"100%"}}>
                                    <RangeControl
                                        
                                        beforeIcon="editor-textcolor"
                                        min={0}
                                        max={300}
                                        step={0.1}
                                        initialPosition={16}
                                        value={props.attributes.label_size}
                                        onChange={(new_val) => {
                                            props.setAttributes({ label_size: new_val })
                                        }}
                                    />
                                </div>

                                              <Button style={{
                                            background: 'transparent', border: '1px solid #007cba', fontSize: '12px',width:"22%",height:"30px", padding:"6px",color:"#007cba"
                                            }}
                                            onClick={() => {
                                            props.setAttributes({label_size:"16"})
                                            }}> Reset 
                                        </Button>
                                </div>
                                <SelectControl
                                    label="Font Family"
                                    options={all_font_families}
                                    onChange={(new_val) => {
                                        props.setAttributes({ label_fontfamily: new_val })
                                    }}
                                    value={props.attributes.label_fontfamily}
                                />
                                <SelectControl
                                    label="Font Weight"
                                   options={font_weight_list}
                                    onChange={(new_val) => {
                                        props.setAttributes({ label_fontweight: new_val })
                                    }}
                                    value={props.attributes.label_fontweight}
                                />
                                <div style={{ display: "flex", alignItems: "center" }}>
                                    <p style={{ marginRight: 30 }}>Line Height</p>
                                    <Button style={{ padding: 1, marginRight: 4, boxShadow: 0, height: 20, backgroundColor: "#e4e5e5", color: "#23282d", borderRadius: "50%" }}>
                                        <span> <Dashicon icon="desktop" style={{ fontSize: 15 }} /></span></Button>
                                    <Button style={{ padding: 1, marginRight: 4, boxShadow: 0, height: 20, backgroundColor: "#e4e5e5", color: "#23282d", borderRadius: "50%" }}>
                                        <span><Dashicon icon="tablet" style={{ fontSize: 15 }} /></span></Button>
                                    <Button style={{ padding: 1, marginRight: 4, boxShadow: 0, height: 20, backgroundColor: "#e4e5e5", color: "#23282d", borderRadius: "50%" }}>
                                        <span><Dashicon icon="phone" style={{ fontSize: 15 }} /></span></Button>
                                    <Button onClick={changeLineheightPx} id="changelinpx" style={{ fontSize: 15, paddingLeft: 5, paddingRight: 5 }}><span style={{ height: 30 }}>px</span></Button>
                                    <Button onClick={changeLineheightEm} id="changelinem" style={{ fontSize: 15, padding: 0 }}><span style={{ height: 30 }}>em</span></Button>
                                </div>

                                <div className="range-controler" style={{display:"flex"}}>
                                
                                        
                                <div style={{marginRight:"10px",width:"100%"}}>
                                <RangeControl
                                   step={0.1}
                                    beforeIcon="editor-textcolor"
                                    min={0}
                                    max={300}
                                    initialPosition={30}
                                    value={props.attributes.label_lineheight}
                                    onChange={(new_val) => {
                                        props.setAttributes({ label_lineheight: new_val })
                                    }}
                                />
                                </div>
                                <Button style={{
                                            background: 'transparent', border: '1px solid #007cba', fontSize: '12px',width:"22%",height:"30px", padding:"6px",color:"#007cba"
                                            }}
                                            onClick={() => {
                                            
                                            props.setAttributes({label_lineheight:"30"})
                                            }}> Reset 
                                        </Button>
                                </div>
                            </div>
                        </CardBody>
                    </Card>
                    <RangeControl
                        label='Background Size'
                        value={props.attributes.bg_size}
                        help='Note: Background Size option is useful when one adds background color to the icons.'
                        min={0}
                        max={500}
                        initialPosition={0}
                        onChange={(new_value) => {
                            props.setAttributes({ bg_size: new_value })
                        }}
                    />
                    <RangeControl
                        label='Border'
                        value={props.attributes.border}
                        help='Note: Border option is useful when one adds border color to the icons.    '
                        min={0}
                        max={10}
                        default={0}
                        onChange={(new_value) => {
                            props.setAttributes({ border: new_value })
                        }}
                    />
                    <RangeControl
                        label='Radius'
                        value={props.attributes.radius}
                        help='Note: Border Radius option is useful when one adds background color to the icons.'
                        min={0}
                        max={500}
                        initialPosition={0}
                        onChange={(new_value) => {
                            props.setAttributes({ radius: new_value })
                        }}
                    />
                </PanelBody>
                <PanelBody title={__('Icon Setting', 'icon-list')} initialOpen={false}>
                    <SelectControl
                        label={__("Image/Icon", 'icon-list')}
                        options={[ 
                            { label: 'Image', value: 'img' },
                            { label: 'Icon', value: 'icon' },
                        ]}
                        onChange={(new_val) => {
                            props.setAttributes({ icon_img: new_val })
                            imgIcon(new_val)
                        }}
                        value={props.attributes.icon_img}
                    />
                    <div id="icon-container">
                    <IconPicker
                            allowReset={false}
                            value={props.attributes.icon_selector}
                       
                            onChange={(newIcon) => props.setAttributes({ icon_selector: newIcon })}
                   />
                        
                        <hr />
                        <h3>List item Link</h3>
                        <ToggleControl
                            label="Disable Link "
                            checked={props.attributes.hide_icon_labels}
                            onChange={(new_val) => {
                                props.setAttributes({ hide_icon_labels: new_val })
                                hide_icon_control(new_val)
                            }}
                        />
                        <div id="hide-icon">
                            <p>URL</p>
                            <TextControl className='text-control'
                                label='Input Text'
                                value={props.attributes.link_field}
                                onChange={(new_value) => {
                                    props.setAttributes({ link_field: new_value })
                                }}
                            />
                        </div>
                        <hr />
                        <p>Icon Color Setting</p>
                        <TabPanel className="my-tab-panel"
                            activeClass="active-tab"
                            tabs={[
                                {
                                    name: 'Normal',
                                    title: 'Text Color',
                                    className: <ColorPalette
                                        colors={color_palette_list}
                                        value={props.attributes.text_color_palette}
                                        onChange={(new_val) => {
                                            props.setAttributes({ text_color_palette: new_val })
                                        }}
                                    />,
                                    value: <ColorIndicator colorValue={props.attributes.text_color_palette} />
                                },
                                {
                                    name: 'Hover',
                                    title: 'Text Hover',
                                    className: <ColorPalette
                                        colors={color_palette_list}
                                        value={props.attributes.hover_text_color_palette}
                                        onChange={(new_val) => {
                                            props.setAttributes({ hover_text_color_palette: new_val })
                                        }}
                                    />,
                                    value: <ColorIndicator colorValue={props.attributes.hover_text_color_palette} />
                                },
                            ]}>
                            {
                                (tab) => <div>
                                    <br />
                                    <p>{tab.value} {tab.title}</p>
                                    <p>{tab.className}</p>
                                </div>
                            }
                        </TabPanel>
                        <TabPanel className="my-tab-panel"
                            activeClass="active-tab"
                            tabs={[
                                {
                                    name: 'Normal',
                                    title: 'Icon Color',
                                    className: <ColorPalette
                                        colors={color_palette_list}
                                        value={props.attributes.icon_color_palette}
                                        onChange={(new_val) => {
                                            props.setAttributes({ icon_color_palette: new_val })
                                        }}
                                    />,
                                    value: <ColorIndicator colorValue={props.attributes.icon_color_palette} />
                                },
                                {
                                    name: 'Hover',
                                    title: 'Icon Hover',
                                    className: <ColorPalette
                                        colors={color_palette_list}
                                        value={props.attributes.hover_icon_color_palette}
                                        onChange={(new_val) => {
                                            props.setAttributes({ hover_icon_color_palette: new_val })
                                        }}
                                    />,
                                    value: <ColorIndicator colorValue={props.attributes.hover_icon_color_palette} />
                                },
                            ]}>
                            {
                                (tab) => <div>
                                    <br />
                                    <p>{tab.value} {tab.title}</p>
                                    <p>{tab.className}</p>
                                </div>
                            }
                        </TabPanel>
                        <TabPanel className="my-tab-panel"
                            activeClass="active-tab"
                            tabs={[
                                {
                                    name: 'Normal',
                                    title: 'Background Color',
                                    className: <ColorPalette
                                        colors={color_palette_list}
                                        value={props.attributes.icon_background_color_palette}
                                        onChange={(new_val) => {
                                            props.setAttributes({ icon_background_color_palette: new_val })
                                        }}
                                    />,
                                    value: <ColorIndicator colorValue={props.attributes.icon_background_color_palette} />
                                },
                                {
                                    name: 'Hover',
                                    title: 'Background Hover',
                                    className: <ColorPalette
                                        colors={color_palette_list}
                                        value={props.attributes.hover_icon_background_color_palette}
                                        onChange={(new_val) => {
                                            props.setAttributes({ hover_icon_background_color_palette: new_val })
                                        }}
                                    />,
                                    value: <ColorIndicator colorValue={props.attributes.hover_icon_background_color_palette} />
                                },
                            ]}>
                            {
                                (tab) => <div>
                                    <br />
                                    <p>{tab.value} {tab.title}</p>
                                    <p>{tab.className}</p>
                                </div>
                            }
                        </TabPanel>
                        <TabPanel className="my-tab-panel"
                            activeClass="active-tab"
                            tabs={[
                                {
                                    name: 'Normal',
                                    title: 'Border Color',
                                    className: <ColorPalette
                                        colors={color_palette_list}
                                        value={props.attributes.icon_border_color_palette}
                                        onChange={(new_val) => {
                                            props.setAttributes({ icon_border_color_palette: new_val })
                                        }}
                                    />,
                                    value: <ColorIndicator colorValue={props.attributes.icon_border_color_palette} />
                                },
                                {
                                    name: 'Hover',
                                    title: 'Border Hover',
                                    className: <ColorPalette
                                        colors={color_palette_list}
                                        value={props.attributes.hover_icon_border_color_palette}
                                        onChange={(new_val) => {
                                            props.setAttributes({ hover_icon_border_color_palette: new_val })
                                        }}
                                    />,
                                    value: <ColorIndicator colorValue={props.attributes.hover_icon_border_color_palette} />
                                },
                            ]}>
                            {
                                (tab) => <div>
                                    <br />
                                    <p>{tab.value} {tab.title}</p>
                                    <p>{tab.className}</p>
                                </div>
                            }
                        </TabPanel>
                    
                    
                    </div>
                    <div id="img-container" style={{ display: 'none' }}>
                        <div id='img-body'>
                            {props.attributes.img_ID ? (
                                <div className="image-ctr">
                                    <img src={props.attributes.img_URL}
                                        alt={props.attributes.img_alt} />
                                    {props.isSelected ? (
                                        <Button className="btn-remove" onClick={remove_img}>
                                            <Dashicon icon='no' />
                                        </Button>
                                    ) : null}
                                </div>
                            ) : (
                                <MediaUploadCheck>
                                    <MediaUpload
                                        allowedType={['image']}
                                        value={props.attributes.img_ID}
                                        onSelect={select_img}
                                        render={({ open }) => (
                                            <Button className={"button button-large"} onClick={open}>
                                                {__('Upload Image', 'Blocks Bakery')}
                                            </Button>
                                        )}></MediaUpload>
                                </MediaUploadCheck>
                            )}
                        </div>
                        <   hr />
                        <h3>List item Link</h3>
                        <ToggleControl
                            label="Disable Link"
                            checked={props.attributes.hide_img_label}
                            onChange={(new_val) => {
                                props.setAttributes({ hide_img_label: new_val })
                                hide_img_control(new_val)
                            }}
                        />
                        <div id="hide-img">
                            <p>URL</p>
                            <TextControl className='text-control'
                                label='Input Text'
                                value={props.attributes.text_field}
                                onChange={(new_value) => {
                                    props.setAttributes({ text_field: new_value })
                                }}
                            />
                        </div>
                        <hr />
                        <TabPanel className="my-tab-panel"
                            activeClass="active-tab"
                            onSelect={(tabName) => {
                                console.log('Selecting tab', tabName);
                            }}
                            tabs={[
                                {
                                    name: {
                                        n1: <ColorPalette
                                            value={props.attributes.text_color_palette}
                                            colors={
                                                color_palette_list}
                                            onChange={(new_val) => {
                                                props.setAttributes({ img_border_color_palette: new_val })
                                            }}
                                        />,
                                    },
                                    value: {
                                        v1: <ColorIndicator colorValue={props.attributes.text_color_palette} />,
                                        v2: <ColorIndicator colorValue={props.attributes.img_background_color_palette} />,
                                        v3: <ColorIndicator colorValue={props.attributes.img_border_color_palette} />,
                                    },
                                    title: 'Image',
                                    className: 'tab-one',
                                },
                                {
                                    name: {
                                        n1: <ColorPalette
                                            colors={
                                                color_palette_list}
                                            onChange={(new_val) => {
                                                props.setAttributes({ hover_img_border_color_palette: new_val })
                                            }}
                                        />,
                                    },
                                    value: {
                                        v1: <ColorIndicator colorValue={props.attributes.hover_text_color_palette} />,
                                        v2: <ColorIndicator colorValue={props.attributes.hover_img_background_color_palette} />,
                                        v3: <ColorIndicator colorValue={props.attributes.hover_img_border_color_palette} />,
                                    }
                                    ,
                                    title: "Hover",
                                    className: 'tab-two',
                                },
                            ]}>
                            {
                                (tab) =>
                                    <div className={props.className}>
                                        <p>{tab.button}</p>
                                        <p>Text Color {tab.value.v1}</p>
                                        <p>{tab.name.n1}</p>
                                        <hr />
                                        <p>{tab.title} Background Color {tab.value.v2}</p>
                                        <p>{tab.name.n2}</p>
                                        <hr />
                                        <p> {tab.title}  Border Color {tab.value.v3}</p>
                                        <p>{tab.name.n3}</p>
                                        <hr />
                                    </div>
                            }
                        </TabPanel>
                    </div>
                </PanelBody>
            </InspectorControls>,
            <div className="gb-icon-list"
                style={{
                    marginBottom: props.attributes.items_gap,
                }}  >
                <div className="gb-il-wrap" style={{ display: 'flex', flexDirection: 'row', alignItems: "center" }}>
                    <a className="gb-il-field" href={props.attributes.link_field} style={{ textDecoration: 'none' }} >
                        <span
                            className={props.attributes.icon_selector}
                            onMouseOver={onChangeIcon}
                            onMouseLeave={sameIcon}
                            style={{
                                marginTop: '7px',
                                border: 'solid',
                                display: props.attributes.iconDisplay,
                                height: 'auto',
                                width: 'auto',
                                fontSize: props.attributes.icon_size,
                                padding: props.attributes.bg_size,
                                borderWidth: props.attributes.border,
                                borderRadius: props.attributes.radius,
                                color: props.attributes.icon_color_palette,
                                backgroundColor: props.attributes.icon_background_color_palette,
                                borderColor: props.attributes.icon_border_color_palette,
                            }}
                            icon={props.attributes.select_icon}></span>
                    </a>
                    <a className="gb-il-tlink" href={props.attributes.text_field} style={{ textDecoration: 'none' }} >
                        <span style={{
                            display: props.attributes.imgDisplay,
                            padding: props.attributes.bg_size,
                            border: 'solid',
                            borderColor: props.attributes.img_border_color_palette,
                            borderWidth: props.attributes.border,
                            backgroundColor: props.attributes.img_background_color_palette,
                            borderRadius: props.attributes.radius
                        }}
                        >
                            <img
                                className="gb-il-image"
                                onMouseOver={onChangeImg}
                                onMouseLeave={sameImg}
                                src={props.attributes.img_URL} width='20'
                                style={{
                                    width: props.attributes.icon_size,
                                    border: 'solid',
                                    borderColor: props.attributes.img_border_color_palette,
                                    borderWidth: props.attributes.border,
                                    backgroundColor: props.attributes.img_background_color_palette,
                                    borderRadius: props.attributes.radius,
                            
                                    padding: props.attributes.bg_size,
                           
                                }} />
                        </span>
                    </a>
                    <RichText
                        className="gb-il-icon1"
                        style={{
                            display: props.attributes.displayLabel,
                            fontSize: props.attributes.label_size + props.attributes.chngfontem,
                            color: props.attributes.text_color_palette,
                            marginTop: props.attributes.labelMargin,
                            fontFamily: props.attributes.label_fontfamily, fontWeight: props.attributes.label_fontweight,
                            lineHeight: props.attributes.label_lineheight + props.attributes.chnglineght,
                            marginLeft: props.attributes.icon_labels_gap,
                        }}
                        onMouseOver={onChangeLabel}
                        onMouseLeave={sameLabel}
                        value={props.attributes.label_value}
                        onChange={(new_val) => {
                            props.setAttributes({ label_value: new_val })
                        }} />
                </div>
            </div>
        ]
    },

    save: (props) => {
        const onChangeIcon = (e) => {
            e.target.style.color = props.attributes.hover_icon_color_palette
            e.target.style.backgroundColor = props.attributes.hover_icon_background_color_palette
            e.target.style.borderColor = props.attributes.hover_icon_border_color_palette
        }
        const sameIcon = (e) => {
            e.target.style.color = props.attributes.icon_color_palette
            e.target.style.backgroundColor = props.attributes.icon_background_color_palette
            e.target.style.borderColor = props.attributes.icon_border_color_palette
        }
        const onChangeLabel = (e) => {
            e.target.style.color = props.attributes.hover_text_color_palette
        }
        const sameLabel = (e) => {
            e.target.style.color = props.attributes.text_color_palette
        }
        const onChangeImg = (e) => {
            e.target.style.backgroundColor = props.attributes.hover_img_background_color_palette
            e.target.style.borderColor = props.attributes.hover_img_border_color_palette
        }
        const sameImg = (e) => {
            e.target.style.backgroundColor = props.attributes.img_background_color_palette
            e.target.style.borderColor = props.attributes.img_border_color_palette
        }
        return (
            <div className="gb-icon-list"
                style={{
                    marginBottom: props.attributes.items_gap,
                }}        >
                <div className="gb-il-wrap" style={{ display: 'flex', flexDirection: 'row', alignItems: "center" }}>

                    <a lassName="gb-il-field" href={props.attributes.link_field} style={{ textDecoration: 'none' }}>
                        <span
                           className={props.attributes.icon_selector}
                            onMouseOver={onChangeIcon}
                            onMouseLeave={sameIcon}
                            style={{
                                marginTop: '7px',
                                border: 'solid',
                                height: 'auto',
                                width: 'auto',
                                display: props.attributes.iconDisplay,
                                fontSize: props.attributes.icon_size,
                                padding: props.attributes.bg_size,
                                borderWidth: props.attributes.border,
                                borderRadius: props.attributes.radius,
                                color: props.attributes.icon_color_palette,
                                backgroundColor: props.attributes.icon_background_color_palette,
                                borderColor: props.attributes.icon_border_color_palette,
                            }}
                            icon={props.attributes.select_icon}></span>
                    </a>
                    <a className="gb-il-tlink" href={props.attributes.text_field} style={{ textDecoration: 'none' }}>
                        <span className="gb-il-image-wrap"
                            style={{
                                display: props.attributes.imgDisplay,
                                padding: props.attributes.bg_size,
                                border: 'solid',
                                borderColor: props.attributes.img_border_color_palette,
                                borderWidth: props.attributes.border,
                                backgroundColor: props.attributes.img_background_color_palette,
                                borderRadius: props.attributes.radius
                            }}
                        >
                            <img
                                className="gb-il-image"
                                onMouseOver={onChangeImg}
                                onMouseLeave={sameImg}
                                src={props.attributes.img_URL} width='20'
                                style={{
                                    width: props.attributes.icon_size,
                                    border: 'solid',
                                    borderColor: props.attributes.img_border_color_palette,
                                    borderWidth: props.attributes.border,
                                    backgroundColor: props.attributes.img_background_color_palette,
                                    borderRadius: props.attributes.radius,
                            
                                    padding: props.attributes.bg_size,
                                   
                          
                                  
                                    
                                }} />
                        </span>                    </a>
                    {/* </div> */}
                    <div  className="bb-il-icon" style={{
                        display: props.attributes.displayLabel,
                        marginLeft: props.attributes.icon_labels_gap,
                        lineHeight: `${props.attributes.icon_size + props.attributes.bg_size + props.attributes.bg_size}px`,
                        color: props.attributes.text_color_palette,
                        fontSize: props.attributes.label_size + props.attributes.chngfontem,
                        fontFamily: props.attributes.label_fontfamily, fontWeight: props.attributes.label_fontweight,
                        lineHeight: props.attributes.label_lineheight + props.attributes.chnglineght,
                        marginTop: props.attributes.labelMargin
                    }}>
                        <RichText.Content
                          
                            onMouseOver={onChangeLabel}
                            onMouseLeave={sameLabel}
                            value={props.attributes.label_value}
                        />
                    </div>
                </div>
            </div>
        )
    },
})